<template>
  <f-dialog
    v-if="visibleDialog"
    ref="dialog"
    v-bind="dialogProps"
    @close="onClose"
  />
</template>

<script>
import FDialog from "@/components/dialog/FDialog";

export default {
  name: "ConfirmDialog",
  components: { FDialog },
  data() {
    return {
      visibleDialog: false,

      title: "",
      message: "",
      callback: () => {},
      closeCallback: () => {},
      result: false,
    };
  },
  computed: {
    dialogProps() {
      return {
        title: this.title,
        message: this.message,
        buttonListItems: [
          {
            id: "confirmDialogOkay",
            class: "confirm keyColor",
            buttonOptions: {
              text: this.$t("main.popupButton.baseRightBtnText"),
              listeners: {
                click: this.onOkayClick,
              },
            },
          },
          {
            class: "close",
            buttonOptions: {
              text: this.$t("main.popupButton.baseLeftBtnText"),
              listeners: {
                click: this.onCloseClick,
              },
            },
          },
        ],
      };
    },
  },
  methods: {
    show({ title, message, callback }) {
      this.title = title;
      this.message = message;
      this.callback = callback;

      this.result = false;
      this.visibleDialog = true;
      this.$nextTick(() => {
        this.$refs["dialog"].show();
      });
    },
    hide() {
      this.$refs["dialog"].hide();
    },
    onClose() {
      this.callback(this.result);
      this.visibleDialog = false;
    },
    onOkayClick() {
      this.result = true;
      this.hide();
    },
    onCloseClick() {
      this.result = false;
      this.hide();
    },
  },
};
</script>

<style scoped></style>
